require('../../modules/es.object.entries');

module.exports = require('../../internals/path').Object.entries;
